import React from 'react';
import './ComingSoonTag.scss';
import { useTranslation } from 'react-i18next';

interface ComingSoonTagProps {
  className?: string;
  overrideText?: string;
}

const ComingSoonTag: React.FC<ComingSoonTagProps> = ({ className = '', overrideText }) => {
  const { t } = useTranslation();
  return (
    <span className={`coming-soon-tag ${className}`}>
      {overrideText ?? t('components:coming_soon_tag')}
    </span>
  );
};

export default ComingSoonTag;
